function Chart(dom) {
  this.data = {
    title: {
      text: "注：数据来源于铅笔道DATA",
      x: "right",
      textStyle: {
        fontSize: 12,
        fontWeight: "normal"
      }
    },
    grid: {
      x: 50,
      y: 45,
      x2: 5,
      y2: 90,
      borderWidth: 1
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}行业 <br/> 一共成立公司{c}家<br/>• 点击可以查看二级行业"
    },
    textStyle: {
      color: "#6c7179"
    },
    xAxis: {
      axisLabel: {
        interval: 0,
        rotate: 30
      },
      data: [],
      show: false
    },
    yAxis: {
      show: false
    }
  };
  this.dom = dom;
  this.chart = echarts.init(this.dom);
  this.render();
}

Chart.prototype.setData = function(obj, ext) {
  ext = ext || {};
  // this.data = Object.assign(this.data, obj);
  this.data = $.extend(true, obj, ext);
  // this.data = obj;
  this.render();
};

Chart.prototype.render = function() {
  this.chart.setOption(this.data, true);
  this.chart.resize();
};

Chart.prototype.on = function(type, fn) {
  this.chart.on(type, fn);
};
